export const provenience=[
    'C. Licinella (1967)',
    'Madrid',
    'from C. Andriuolo (1971), T. 18',
    'from same tomb',
    'Not specified',
    'Gela',
    'Naples',
    'Dublin',
    'Brisbane',
    'Lipari',
    'Munich',
    'Scoglitti, T. 277',
    'Sicily',
    'Castelcapuano, T. 16',
    'Sicily (Messina?)',
    'Catania',
    'Rainone coll.',
    'New York',
    'C. Andriuolo (1969), T. 11',
    '-',
    'L. 373',
    'L. 372',
    'L. 385',
    'L. 378',
    'L. 375',
    'L. 386',
    'from S. Agata',
    'B.M. F',
    'Salerno',
    'Warsaw',
    'Paestum',
    'S. Agata',
    'from Roccadaspide, Fondo Castagno (1963), T. 4',
    'from T. 1181',
    'fromTeggiano',
    'B.M.',
    'Fusco necropolis',
    'Monte Adranone, T. 1',
    'Melbourne',
    'Odessa',
    'T. 614',
    'Ragusa',
    'Geneva',
    'Zurich',
    'Nocera',
    'Vatican',
    'Montesarchio, T. 586',
    'Montesarchio, T. 361',
    'Montesarchio',
    'Dundee',
    'Dunedin',
    'Agrigento',
    'Florence',
    'Sydney',
    'Richmond',
    'Berlin',
    'Basel',
    'Reading',
    'London',
    'Louvre',
    'Wurzburg',
    'Hanover',
    'Liverpool',
    'St. David\'s (Pa.)',
    'The Hague',
    'Richmond (Virginia)',
    'Lucerne',
    'Pontecagnano',
    'Los Angeles',
    'Mannheim',
    'Boston',
    'Chicago',
    'Bonn',
    'Rome',
    'Stockholm',
    'Trieste',
    'Toulouse',
    'Compiegne',
    'Monopoli',
    'Leiden',
    'Westphalia',
    'Bucharest',
    'Montesarchio, T. 332',
    'Montesarchio, T. 891',
    'Avella',
    'C. Andriuolo, 13-6-1974—Prop. Cuomo Francersca',
    'Mus. Prov. Pc 1811, Pontecagnano',
    'Kurashiki Ninagawa Museum',
    'Thonon',
    'Oliveto Gitra',
    'Arenosola',
    'Eboli',
    'T. 3711, no. 18',
    'Spinazzo',
    'Spinazzo (sporadic)',
    'T. 1',
    'C. Andriuolo (1955)',
    'Agropoli, T. 6',
    'C. Andriuolo (1969)',
    'C. Andriuolo (1971)',
    'Paestum, from C. Andriuolo (1969)',
    'H o p e',
    'Moscow',
    'Deepdene',
    'Hamburg',
    'from Gromola (Stregara) (1960), T. 2',
    'from Oliveto Citra',
    'from Oliveto Citra, T. 17',
    'from Arenosola',
    'from C. Licinella (1968), T. 39',
    'from Tempa del Prete (1953), T. 3',
    'from C. Spina-Gaudo (1979), T. 58',
    'from C. Spina-Gaudo (1979), T. 71',
    'from Spinazzo (1963), T. 6',
    'from C. Andriuolo (1954), T. 27',
    'once Nostell Priory 17',
    'from Montesarchio, T. 731',
    'from Montesarchio, T. 303',
    'from Montesarchio, T. 331',
    'from Montesarchio, T. 94',
    'from Montesarchio, sporadic',
    'from Montesarchio, T. 163',
    'from Montesarchio, T. 103',
    'from C. Arcioni (1976), T. 1',
    'from Tempa del Prete (1953), T. 15',
    'Alle Querce',
    'now in the University—Winckelmanns Institut',
    'from C. Laghetto (1955), T. 120',
    'Dr. Elefanti, from Eboli (1829)',
    'from Montesarchio, T. 1421',
    'from Abella',
    'De Bellis coll. 90',
    'from Tempa del Prete (1953), T. 12',
    'from C. Andriuolo (1954), T. 1',
    'from the Heraion, Loc. IV',
    'from Spinazzo (1972), T. 76',
    'from Tempa del Prete (1953), T. 8',
    'from the area of the Heraion, Loc. IV',
    'from C. Andriuolo (1954), T. 5',
    'from Fuscillo (1956), T. 14',
    'Canberra',
    'Naples, Via Cirillo, T. 3',
    'T. 1675 A',
    'T. 974',
    'T. 921',
    'T. 367',
    'Taranto',
    'S. Venera',
    'Tampa',
    'Palazzuolo',
    'T. 24',
    'London Market',
    'Lentini',
    'T. 1050',
    'T. 1675a',
    'from Paestum',
    'Napoli, Tomba del Tuffatore, p. 164, figs. 88-90',
    'Basel, M u M , List 1984, no. 182; Sotheby, Sale Cat. 9-10 July 1984, no. 344, ill. on pp. 150-1',
    'from C. Laghetto (1955), T. 65',
    'Bari',
    'Paris',
    'Bochum',
    'from C. Andriuolo (1955), T. 21',
    'from C. Andriuolo (1954), T. 19',
    'from C Spina (1963), T. 13',
    'T. 901',
    'C. Gaudo (1957), T. 10',
    'C. Andriuolo (1969), T. 48',
    'C. Licinella (1968), T. 30',
    'Agropoli (1967), T. 1',
    'from the area of the Basilica',
    'Leningrad',
    'Perugia',
    'Cambridge (Mass.)',
    'New York Market',
    'Capua',
    'Turin',
    'Naples, from Paestum',
    'Paestum, from C. Andriuolo (1969), T. 8',
    'Paestum, from C. Arcioni (1953), T. 9',
    'Paestum, from C. Licinella (1967), T. 6',
    'Paestum, from C. Licinella (1968), T. 14',
    'Paestum, from C. Gaudo (1957), T. 10',
    'Melbourne, ex London Market, Sotheby, Sale Cat. 4 Dec. 1979, no. 110; 19 May 1986, no. 279',
    'Paestum, from C. Andriuolo (1969), T. 28',
    'Sale Cat. 12 June 1985, no. 25 (ill.)',
    'from Stregara (1960), T. 2',
    '2 July 1982, no. 202, ill. on p. 36. Ex Geneva Market, Marie Laforet, Sale Cat. 11 Dec. 1980, no. 79; then Basel Market, Palladion',
    'from C. Gaudo (1957), T. 11',
    'from Tricarico (Bosco della Fonti)',
    'from Agropoli, T. 6',
    'from Paestum (Heraion)',
    'from C. Andriuolo (1969), T. 41',
    'from C. Andriuolo (1955), T. 32',
    'from C. Andriuolo (1971), T. 4',
    'fDr. Lauffenburget',
    'from C. Andriuolo (1954), T. 18',
    'from C. Andriuolo (1969), T. 86',
    'from C. Gaudo (1957), T. 6',
    'from the Heraion, west of Loc. IV',
    'T. 104',
    'Locri',
    'From a building near the Temenos',
    'From Contrada Laghetto (1956), sporadic',
    'from Buccino',
    'Agora at Paestum',
    'Swiss',
    'Selinunte',
    'C. Andriuolo (1976), sporadic.',
    'C. Andriuolo (1954), T. 2',
    'Ex. Hope 265',
    'from Fuscillo (1956), T. 4',
    'from C. Andriuolo (1969), T. 3',
    'from C. Andriuolo (1954), T. 45',
    'from Tempa del Prete (1953), T. 16',
    'from C. Licinella (1969), T. 31',
    'from Pontecagnano',
    'Santa Venera',
    'San Francisco',
    'Athens',
    'Fratte',
    'Japan (Private Collection)',
    'Palermo',
    'Auxerre',
    'San Antonio (Texas)',
    'Once Nocera',
    'Buenos Aires',
    'Purchase (N.Y.)',
    'Vienna',
    'Avignon',
    'Padula',
    'Paestum, from C. Gaudo (1972)',
    'Paestum, from the area of the Heraion, Loc. IV.',
    'Lisbon',
    'Tempa del Prete (1953)',
    'S. Cesareo Albanella (1957)',
    'from Spinazzo (sporadic)',
    'from C. Arcioni (1953), T. 4',
    'from C. Gaudo (1957), T. 8',
    'from C. Andriuolo (1955), T. 30',
    'From a calyx-krater',
    'From a bell-krater',
    'Scottsdale',
    'Napoli, Tomba del Tuffatore, p. 142, fig. 49; Hurschmann, op. cit., p. 149 and p. 198, no. P4.',
    'Ascona',
    'Cambridge',
    'from T. 772',
    'Summa Galleries 775',
    'Ex Loudmer et Poulain, Sale Cat. 4-6 Dec. 1980, no. 96, pi. 2, 1',
    'from C. Licinella (1969), sporadic',
    'from Spinazzo (1972), T. 86',
    'Heraion, Loc. IV',
    'area of the Heraion, Loc. IV, level 8',
    'area of the Heraion, Loc. IV',
    'from S. Venera (1976), T. 74 bis',
    'L. 440',
    'L. 439',
    'Agropoli',
    'Cologne',
    'Nostell Priory',
    'Urbana-Champaign',
    'C. Spina-Gaudo (1970), T. 1.',
    'C. Andriuolo-Laghetto (1955)',
    'Roccadaspide Tempalta',
    'T e m p a del Prete (1953)',
    'Avella (1981)',
    'Altavilla',
    'C. Gaudo (1957)',
    'Kurashiki Museum',
    'Tepedino',
    'C. Spina (1963)',
    'S. Venera (1976)',
    'C. Linora (1964)',
    'C. Andriuolo-Laghetto (1954)',
    'Teggiano',
    'T. 1593 (1968)',
    'C. Licinella (1957)',
    'San Antonio',
    'Heraion, north of Loc. IV',
    'from C. Andriuolo (1982), T. 680',
    'from Spinazzo, T. 10',
    'from the area of the Heraion, north of Loc. IV',
    'from S. Cesareo Albanella (1957), T. 7',
    'from C. Linora (1964), T. 12',
    'from Tempa del Prete (1974), T. 9',
    'from Tempa del Prete (1953), T. 13',
    'from C. Spina (1963), T. 4',
    'from C. Licinella (1967), T. 20',
    'from C. Spina-Gaudo (1979), T. 70',
    'from C. Spina-Gaudo (1979), T. 73',
    'from Tempa del Prete (1968), T. 3',
    'from C. Andriuolo (1969), T. 10',
    'from C. Andriuolo (1969), T. 45',
    'from C. Laghetto (1967), sporadic',
    'from C. Laghetto (1956), T. 5',
    'from C. Andriuolo (1969), T. 47',
    'from Spinazzo (1973), T. 9',
    'from C. Andriuolo-Laghetto (1955), T. 63',
    'from Spinazzo (1974), T. 32',
    'from C. Andriuolo (1969), T. 14',
    'ex Gy (Geneva), S fDr. Lauffenburger, from Castellammare',
    'from C. Andriuolo (1971), T. 2',
    'from C. Andriuolo (1971), T. 15',
    'from the Heraion, north of Loc. IV',
    'from same area (fr.)',
    'from same area',
    'from the Heraion, Loc. II',
    'from the Heraion, north of Loc. IV (frr.)',
    'from T. 901',
    'Tempa Rossa di Fonte (1964)',
    'Ruvo',
    'C. Gaudo (1957), T. 12',
    'C. Spina-Gaudo (1970), T. 1',
    'C. Andriuolo (1971), T. 24',
    'C. Andriuolo (1954), T. 7',
    'Rheinbach',
    'Como',
    'Tokyo',
    'Leipzig',
    'C. Vannullo (1975)',
    'C. Arcioni (1953)',
    'C. Licinella (1968)',
    'Spinazzo (1974)',
    'Tempa del Prete (1974)',
    'Fravita (1956)',
    'Oxford',
    'C. Andriuolo (1954), T. 4',
    'C. Spina-Gaudo (1983), T. 80',
    'C. Andriuolo (1954), T. 15',
    'Spinazzo (1973), T. 4',
    'C. Andriuolo (1955), T. 76',
    'C. Andriuolo-Laghetto (1955), T. 10',
    'Matinelle (Cappa Santa) 1961, T. 6',
    'C. Licinella (1967), T. 10',
    'C. Licinella (1967), T. 12',
    'T. 996',
    'from C. Licinella (1967), T. 7',
    'from C. Spina-Gaudo (24 May 1975)',
    'from C. Gaudo (1957), T. 3',
    'Restored from fragments',
    'from C. Laghetto (1956), sporadic',
    'from C. Andriuolo-Laghetto (1954)',
    'from C. Andriuolo (1954), T. 15',
    'Fuscillo (1956), T. 14',
    'Cumae',
    'from C. Laghetto (1969), sporadic',
    'C. Andriuolo (1969), T. 62',
    'C. Spina (1973), T. 72',
    'from C. Andriuolo (1954), T. 28',
    'from Spinazzo (1972), T. 69',
    'from the Agora',
    'British Museum',
    'Reggio Cal.',
    'from Avella (1981), T. 62 bis',
    'from Heraion, north of Loc. IV',
    'Frankfurt',
    'Mainz',
    'from the area of the Heraion, north of Loc. IV, level 10',
    'from same area, level 8',
    'Haverford',
    'Paestum, C. Andriuolo-Laghetto (1955), T. 94',
    'Paestum, C. Licinella (1968), T. 40',
    'Paestum, Fuscillo (1955), T. 2',
    'Madrid, L. 452',
    'Paestum, Altavilla (1953), T. 1',
    'Madrid, L. 455',
    'Paestum, C. Andriuolo (1969), T. 9',
    'Paestum, Agropoli (1967), T. 1',
    'Rothenbach-Pegnitz, Dr. P. Conradty',
    'Paestum, C. Vannullo (1975), T. 3',
    'Paestum, C. Arcioni (1953), T. 5',
    'Paestum, C. Licinella (1967), T. 20',
    'Paestum, C. Andriuolo (1969), T. 41',
    'Paestum, C. Vannullo (1975), T. 2',
    'Madrid, L. 457',
    'Paestum, C. Andriuolo (1969), T. 79',
    'Salerno, Teggiano, T. 2',
    'Paestum, C. Vannullo (1975)',
    'Kiel',
    'Paestum, C. Andriuolo (1969), T. 32',
    'Paestum, Spinazzo (1973), T. 10',
    'from Spinazzo (1972), T. 75',
    'Locri, T. 892',
    'C. Gaudo (1972)',
    'Dyrrachium',
    'Altavilla (1953), T. 1',
    'Gift of Dr. and Mrs. S. Silverman',
    'C. Andriuolo (1969), T. 102',
    'Nola',
    'Area of the Heraion, north of Loc. IV',
    'Salerno, Mus. Prov.',
    'Roccadaspide, Fondo Castagno',
    'Rio de Janeiro',
    'from C. Licinella (1968), T. 20',
    'from C. Linora (1964), T. 17',
    'Agropoli (Muoio, C. Vecchia, 1967)',
    'L. 400',
    'inv. 81740',
    'L. 399',
    'from C. Andriuolo (1969), T. 88',
    'Private Coll.',
    'Siena',
    'Freiburg',
    'Plymouth',
    'Poughkeepsie',
    'Kassel',
    'Copenhagen',
    'Barcelona',
    'Agropoli (Mattene, 1972)',
    'Limoges',
    'Lugano',
    'Manchester',
    'from C. Gaudo (1957), T. 10',
    'from C. Andriuolo (1969), T. 72',
    'from C. Spina-Gaudo (1979), T. 79',
    'from C. Andriuolo (1969), T. 73',
    'from C. Andriuolo (1969), T. 75',
    'from S. Venera (1976), T. 105',
    'from the Basilicata',
    'from C. Andriuolo-Laghetto (1955), T. 61',
    'from C. Spina-Gaudo (1979), T. 59',
    'from C. Licinella (1968), T. 30',
    'from Agropoli, T. 10',
    'from C. Licinella (1967), T. 14',
    'from C. Arcioni (1953), T. 9',
    'Paestum, from C. Arcioni (1977), T. 348',
    'from Tempa del Prete (1953), T. 10',
    'from Eboli, T. 2',
    'Bourges',
    'Milan',
    'Paestum, from C. Andriuolo (1954)',
    'from C. Laghetto (1969), T. 1 bis',
    'from C. Arcioni (1953), T. 14',
    'from C. Andriuolo-Laghetto (1955), T. 24',
    'from C. Andriuolo (1955), T. 20',
    'Montpellier',
    'Bologna',
    'Agropoli, T. 13',
    'C. Andriuolo (1969), T. 91',
    'from C. Licinella (1967), T. 10',
    'from C. Andriuolo (1969), T. 92',
    'from Nola',
    'Sale Cat. 10 April 1934, no. 120',
    'from C. Andriuolo-Laghetto (1955), T. 21',
    'from C. Andriuolo (1954), T. 36',
    'from C. Arcioni Casabella (1980)',
    'from Foce del Sele, Zone A (fragment)',
    'from C. Andriuolo (1969), T. 182',
    'from Spinazzo (1974), T. 48',
    'from C. Andriuolo (1969), sporadic',
    'Heligoland',
    'Mnichovo Hradiste',
    'from Roccadaspide, Fondo Castagno (1963), T. 2',
    'from Spinazzo',
    'from C. Arcioni (1977), T. 271',
    'from C. Andriuolo (1969), T. 89',
    'from C. Gaudo (1972), T. 1',
    'from T. 784',
    'from C. Arcioni (1953), T. 12',
    'from C. Andriuolo (1955), T. 11',
    'Markos coll.',
    'from Spinazzo, Parco Ogliastro (1955), T. 4',
    'from C. Spina-Gaudo (1979), T. 80',
    'In very fragmentary state',
    'from the Heraion',
    'from C. Andriuolo-Laghetto (1955), T. 95',
    'from C. Andriuolo (1955), T. 18',
    'Syracuse',
    'Bern',
    'San Simeon',
    'Laon',
    'Udine',
    'Vatican City',
    'Viterbo',
    'from C. Andriuolo (1969), H . 102',
    'C. Spina-Gaudo',
    'T. 794',
    'C. Andriuolo (1969), T. 14',
    'C. Gaudo (1957), T. 11',
    'C. Andriuolo (1969), T. 53',
    'C. Andriuolo (1955), T. 18',
    'C. Andriuolo (1969), T. 32',
    'C. Andriuolo (1969), T. 56',
    'Paestum, from C. Arcioni (1953)',
    'from Spinazzo, sporadic',
    'from Tempa del Prete (1974), T. 8',
    'from C. Andriuolo (1954), T. 9',
    'Hazlet (N.J.), Colosseum Coin Exchange',
    'from Spinazzo (Parco Ogliastro, 1955), T. 3',
    'from C. Spina (1963), T. 6',
    'from C. Andriuolo (1969), T. 55',
    'from Spinazzo (1973), T. 10',
    'from C. Andriuolo (1969), T. 8',
    'from Spinazzo (1972), T. 28',
    'from Spinazzo (1972), T. 4',
    'Baranello',
    'from C. Gauda (1970), T. 144',
    'Abella',
    'from C. Andriuolo (1969), T. 57',
    'Acropolis',
    'inv. 82158, from Paestum',
    'from C. Andriuolo (1969), T. 39',
    'from C. Spina (1963), T. 9',
    'from vicinity of Porta Aurea (1932)',
    'Meer',
    'Muoio d\'Agropoli',
    'from C. Gaudo (1957), T. 7',
    'from C. Andriuolo (1969), T. 28',
    'from Capaccio, Campo Sportivo (1964), T. 1',
    'from C. Spina-Gaudo (1979), T. 74',
    'from S. Venera (1976), T. 59',
    'from C. Arcioni (1982), T. 678',
    'from C. Arcioni (1950), T. 2',
    'from C. Andriuolo (1954), T. 10',
    'from C. Andriuolo (1954), T. 37',
    'from Fuscillo',
    'from C. Laghetto (1955), T. 23',
    'from C. Andriuolo-Laghetto (1955), T. 1',
    'from Capaccio (Campo Sportivo, 1964), T. 1',
    'from S. Venera (1976), T. 81',
    'from C. Andriuolo (1954), T. 17',
    'from C. Andriuolo (1969), T. 62',
    'from C. Spina-Gaudo (1963), T. 4',
    'from Motya',
    'T. 81',
    'T. 120',
    'Braunschweig',
    'from C. Andriuolo (1954), T. 42',
    'from C. Gaudio (1957), T. 3',
    'from C. Laghetto-Andriuolo (1955), T. 24',
    'Broken with much missing. Actual height 26.',
    'C. Arcioni (1977), T. 116',
    'from C. Laghetto (1956), T. 70',
    'from Teggiano',
    'from C. Licinella (1968), T. 1',
    'from Tempa del Prete (sporadic)',
    'C. Andriuolo (1969), T. 58',
    'Malibu',
    'from C. Laghetto (1955), T. 30',
    'Royal-Athena Galleries SLP 12, Ex London Market',
    'from C. Arcioni Casabella (1982)',
    'from C. Gaudo (1972), T. 4',
]